'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T($thiz) {
  return (($j_java$002elang$002e$002dObject.$objectGetClass($thiz).kW() + "@") + $thiz.m());
}
export { $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T as $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T };
function $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz) {
  var x = $thiz.dP();
  return ((x === (void 0)) ? $thiz.dd() : x);
}
export { $f_Lcom_raquo_airstream_core_Named__displayName__T as $f_Lcom_raquo_airstream_core_Named__displayName__T };
